import React from 'react'

import { ColorsPalette, CustomTheme } from '@masfront/common-b2c'

import { CssBaseline, makeStyles } from '@material-ui/core'

const useGlobalStyles = makeStyles((palette: ColorsPalette) => ({
  '@global': {
    body: {
      backgroundColor: palette.common?.white,
    },
    '*': {
      boxSizing: 'border-box',
    },
    a: {
      textDecoration: 'none',
    },
    '.line-through': {
      textDecoration: 'line-through',
    },
    '.uppercase': {
      textTransform: 'uppercase',
    },
    '.underline': {
      textDecoration: 'underline',
    },
    img: {
      maxWidth: '100%',
    },
    // Show always scroll to not depending on client OS config
    '*::-webkit-scrollbar': {
      display: 'block',
    },
    '*::-moz-scrollbar': {
      display: 'block',
    },
  },
}))

interface GlobalStylesProps {
  theme: CustomTheme
}

const GlobalStyles: React.FunctionComponent<GlobalStylesProps> = (theme) => {
  useGlobalStyles(theme)
  return <CssBaseline />
}

export default GlobalStyles
